module.exports = __webpack_public_path__ + "static/img/logo.dfd08270.jpg";